var createNewLookupObject = {};

export { createNewLookupObject as __exports };
